function n(n, t, e, r) {
  return new (e || (e = Promise))(function (o, c) {
    function u(n) {
      try {
        i(r.next(n));
      } catch (n) {
        c(n);
      }
    }
    function f(n) {
      try {
        i(r.throw(n));
      } catch (n) {
        c(n);
      }
    }
    function i(n) {
      var t;
      n.done ? o(n.value) : (t = n.value, t instanceof e ? t : new e(function (n) {
        n(t);
      })).then(u, f);
    }
    i((r = r.apply(n, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError;
export { n as __awaiter };